import React from 'react';
import { Link } from 'react-router-dom';
import { Buttons } from '../../Common/Buttons';
import My_Foto from '../../Assets/Me.png';
import myCV from '../..//Assets/Makunin_A.pdf';
import classes from './Preview.module.scss';

export const Preview = () => {
    const mainSkills = [
        'Разработка SPA веб-приложений на основе React.',
        'Работа с React Hooks (useState, useEffect, useContext и другие).',
        'Устранение архитектурных проблем и улучшение структуры кода.',
        'Работа с системами контроля версий (Git).',
        'Взаимодействие с backend-разработчиками для согласования API, и работа с запросами',
        'Адаптивная и кроссбраузерная верстка в компонентах React.',
        'Поддержка и развитие существующего кода, рефакторинг компонентов.',
        'Поддержка и обновление документации по проекту.',
    ];

    return (
        <sectionon className={classes['header__titile']}>
            <div className={classes.container}>
                <div className={classes.content}>
                    <h2 className={classes.title}>
                        Привет, меня зовут Александр Макунин
                    </h2>
                    <p className={classes.subtitle}>
                        Веб разработчик / Фронтенд-разработчик
                    </p>
                    <p className={classes.subtitle}>
                        <ul className={classes['list-skills']} type="disc">
                            {mainSkills.map((skill, index) => (
                                <li key={index}>{skill}</li>
                            ))}
                        </ul>
                    </p>
                    <div className={classes.buttons}>
                        <Link to="/about"><Buttons name="Обо мне" /></Link>
                        <a href={ myCV } download="Makunin_A.pdf"><Buttons name="Скачать CV" /></a>
                    </div>
                </div>
                <div className={ classes.photo }>
                    <img src={ My_Foto } alt="" />
                </div>
            </div>
        </sectionon>
    );
};
